import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const CompanyInfoContext = createContext(null);

export const CompanyInfoProvider = ({ children }) => {
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/company-info`)
      .then(res => setCompanyInfo(res.data))
      .catch(() => {});
  }, []);

  return (
    <CompanyInfoContext.Provider value={companyInfo}>
      {children}
    </CompanyInfoContext.Provider>
  );
};

export const useCompanyInfo = () => useContext(CompanyInfoContext);
